//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from '@/config/index'
import { getList } from '@/api/pintuan'
import Scroll from '@/components/scroller'
export default {
  components: { Scroll },
  data () {
    return {
      baseUrl: config.baseUrl,
      list: [],
      page: 1,
      rows: 20
    }
  },
  mounted () {
    this.loadMoreDom = this.$el.querySelector('.load-more')
    this.listDom = this.$el.querySelector('.list-scroll')
    this.getList()
  },
  methods: {
    // 商品列表
    getList (type, done) {
      getList({
        page: this.page,
        rows: this.rows
      }).then(res => {
        if (res.status === 'suc') {
          if (type === 'refresh') {
            this.list = []
            this.listDom.scrollTop = 0
            this.loadMoreDom.style.display = 'flex'
          }
          let obj = res.returnValue.list
          if (obj.length === 0 && this.page === 1) {
            this.list = []
            this.loadMoreDom.innerText = '暂无数据'
            this.loadMoreDom.style.display = 'flex'
          } else {
            this.list = this.page === 1 ? obj : [...this.list, ...obj]
            if (this.list.length === res.returnValue.total) {
              this.loadMoreDom.style.display = 'none'
            } else {
              this.loadMoreDom.style.display = 'flex'
            }
          }
          done && done()
        }
      })
        .catch(() => {
          this.notFirstLoad = true
          done && done()
        })
    },
    // 下拉刷新
    refresh (done) {
      this.page = 1
      this.loadMoreDom.innerText = '加载中...'
      this.getList('refresh', done)
    },
    // 上拉加载更多
    loadMore (done) {
      this.page++
      this.loadMoreDom.innerText = '加载中...'
      this.getList('more', done)
    },
    goDetail (id) {
      this.$router.push({
        name: 'pintuanDetail',
        params: {
          id: id
        }
      })
    }
  }
}
